import type { AuthPermissionUser } from '../../services/authPermissions';

// ORDER_STAFF = Handlowiec (full product master data, decision 2026-09-23).
const PRODUCT_NAVIGATION_ROLES = ['ADMIN', 'OPERATIONS', 'ORDER_STAFF'];
const USER_MANAGEMENT_NAVIGATION_ROLES = ['ADMIN'];

export function canViewProductNavigation(user: AuthPermissionUser | null | undefined): boolean {
  return PRODUCT_NAVIGATION_ROLES.includes(user?.role || '');
}

export function canViewUserManagementNavigation(user: AuthPermissionUser | null | undefined): boolean {
  return USER_MANAGEMENT_NAVIGATION_ROLES.includes(user?.role || '');
}
